import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/organisme-formation/christie CLAVIER.png")